import React, { useEffect, useState } from "react";
import axios from "axios";
import { formatDate, formatToZMW, rootUrl } from "../../../helpers";
import { useAuth } from "../../../context/auth-context";
import { useOutletContext } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";

export default function TrialBalance({rdata, startDate, endDate}) {
  const [trialBalanceData, setTrialBalanceData] = useState([]);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [loading, setLoading] = useState(true)
  const auth = useAuth();
  const {allData, setAllData} = useOutletContext();
  const fetchData = async () => {
      processTrialBalanceData(rdata);
  };

  

  const processTrialBalanceData = (response) => {
    const trialData = [];
    const processedCoas = new Map();
    let totalDebits = 0;
    let totalCredits = 0;

    const totalBills = sumArray(response.bills.map((res) => parseFloat(res.amount)));
    const totalCred = sumArray(response.supplier.filter((a) => a.type == 1 && a.expense == "None").map((res) => parseFloat(res.amount)));

    // response.bills.forEach((res) => {
    //   const coa = allData.budget?.find(item => item.id === res.coa_id);
    //   // const fromCoa = sumArray(response.journal.filter((a) => a.from_coa === coa.id).map((r) => parseFloat(r.amount)));
    //   // const toCoa = sumArray(response.journal.filter((a) => a.to_coa === coa.id).map((r) => parseFloat(r.amount)));
    //   const credit = parseFloat(res.amount) 
    //   // - fromCoa + toCoa;
    //   const debit = 0;
    //   trialData.push({ code: coa.coa, desc: allData.coa?.find(item => item.account === coa.coa)?.name, debit, credit });
    //   totalCredits += credit;
    // });


    let loan = 0.0

    response.bills.forEach((res) => {
      const coa = allData.budget?.find(item => item.id === res.coa_id);
      if (!coa) return;
    
      const fromCoa = sumArray(response.journal.filter((a) => a.from_coa === coa.id).map((r) => parseFloat(r.amount)));
      const toCoa = sumArray(response.journal.filter((a) => a.to_coa === coa.id).map((r) => parseFloat(r.amount)));
      let amount = 0.0
      if(coa.coa == "157004"){
        loan = res.amount - parseFloat(res.amount) * 0.05;
        amount = parseFloat(res.amount) * 0.05;
      }else{
        amount = parseFloat(res.amount)
      }

      const credit = parseFloat(amount) - fromCoa + toCoa;
      const debit = 0;
      const coaCode = coa.coa;
      const desc = allData.coa?.find(item => item.account === coa.coa)?.name || 'Unknown';
    
      

      if (processedCoas.has(coaCode)) {
        let existing = processedCoas.get(coaCode);
        existing.credit += credit;
      } else {
        processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
      }
      totalCredits += credit;
    });
    
    
    response.journal.forEach((journalEntry) => {
      
      // const boz = response.bills?.find(item => item.coa_id === journalEntry.to_coa);
      // const  soz = response.supplier.filter((a) => a.type == 1)?.find(item => item.coa === journalEntry.to_coa);
      // if (boz || soz ) return; 
        const coaCode = allData.budget?.find(item => item.id === journalEntry.to_coa)?.coa;
        const amount = parseFloat(journalEntry.amount);
        const desc = allData.coa?.find(item => item.account === coaCode)?.name || 'Unknown';
   
        let credit =0 
        let debit =0 
    
          if(coaCode == '326040'){

          }else{
       
            credit = coaCode[0] == "1" ? amount : 0;
            debit = coaCode[0] == "1" ? 0 : amount;
  
            if (credit !== 0) {
              totalCredits += amount;
            } else {
              totalDebits += amount;
            }
    

            if (processedCoas.has(coaCode)) {
              let existing = processedCoas.get(coaCode);
              existing.credit += credit;
              existing.debit += debit;
            } else {
              processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
            }
          }
        
       
      
      
    });
    
    
    response.supplier.filter((a) => a.type == 1 && a.expense == 'None').forEach((res) => {
      const coa = allData.budget?.find(item => item.id === res.coa);
      if (!coa) return; 
    
      const fromCoa = sumArray(response.journal.filter((a) => a.from_coa === coa.id).map((r) => parseFloat(r.amount)));
      const toCoa = sumArray(response.journal.filter((a) => a.to_coa === coa.id).map((r) => parseFloat(r.amount)));
      let amount = 0.0
      if(coa.coa == "321040"){
        amount = parseFloat(res.amount) - loan;
      }else{
        amount = parseFloat(res.amount)
      }
      const debit = parseFloat(amount) - fromCoa + toCoa;
      const credit = 0;
      const coaCode = coa.coa;
      const desc = allData.coa?.find(item => item.account === coa.coa)?.name || 'Unknown';
      

     

      if (processedCoas.has(coaCode)) {
        let existing = processedCoas.get(coaCode);
        existing.debit += debit;

      } else {
        processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
      }
    
      totalDebits += debit;
    });
    
    // trialData.push(...processedCoas.values());

    trialData.push({
      code: "321030",
      desc: "Debtors Control Account",
      debit: totalBills - response.recs[0]?.amount || 0,
      credit: 0,
    });
  
    
    totalDebits += totalBills - response.recs[0]?.amount || 0;

    trialData.push({
      code: "326040",
      desc: "Bank Balances",
      debit: parseFloat(response.cash[0]?.difference) + sumArray(response.opening.filter(a=>a.type == 'Cashbook').map((res) => parseFloat(res.amount))) || 0,
      credit: 0,
    });
    totalDebits += parseFloat(response.cash[0]?.difference) || 0;

    let done = []

    response.supplier.filter((a) => a.expense !== 'None' && a.type == 1).forEach((res) => {

      const coa = res.expense;
      if (!coa) return; 
      const coaCode = coa;
      const isz = allData.budget?.find(item => item.coa === coa)?.id
      const fromCoa = sumArray(response.journal.filter((a) => a.from_coa === isz).map((r) => parseFloat(r.amount)));
      const toCoa = sumArray(response.journal.filter((a) => a.to_coa === isz).map((r) => parseFloat(r.amount)));
      
      
      let amu = 0
      if(done.includes(coa)){
        amu = parseFloat(res.amount)
      }else{
        amu = parseFloat(res.amount) - fromCoa + toCoa
      }
      done.push(coa)
     

      const credit = coaCode == '322020' || coaCode == '322070'?0:parseFloat(amu)
      const debit = coaCode == '322020' ||coaCode == '322070'?parseFloat(amu):0;

      const desc = allData.coa?.find(item => item.account === coa)?.name || 'Unknown';
      
      if (processedCoas.has(coaCode)) {
        let existing = processedCoas.get(coaCode);
        existing.credit += credit;
        existing.debit += debit;

      } else {
        processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
      }
    
      totalCredits += credit;
      totalDebits += debit;
    });
    

    response.debt.forEach((res) => {
      const coa = allData.budget?.find(item => item.id === res.coa);
      if (!coa) return; 
    
      const credit = parseFloat(res.amount)
      const debit = 0;
      const coaCode = coa.coa;
      const desc = allData.coa?.find(item => item.account === coa.coa)?.name || 'Unknown';

      

      if (processedCoas.has(coaCode)) {
        let existing = processedCoas.get(coaCode);
        
        if(res.type == 1){
          existing.credit += credit;
        }else{
          existing.credit -= credit;
        }
        
      } else {
        processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
      }
    
      if(res.type == 1){
        totalCredits += credit;
      }else{
        totalCredits -= credit;
      }
    });
    

    response.opening.forEach((res) => {

      if(res.type == 'COA'){
        const debit = parseFloat(res.amount)
        const credit = 0;
        const coaCode = res.fkey;
        const desc = allData.coa?.find(item => item.account === res.fkey)?.name || 'Unknown';
        
        
        if (processedCoas.has(coaCode)) {
          let existing = processedCoas.get(coaCode);
          // if(res.type == 1){
            existing.debit -= debit;
          // }else{
            // existing.credit -= credit;
          // }        
        } else {
          
          processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
        }
          totalCredits += credit;
      }else{

      }
      
    
     
      
    });


    trialData.push(...processedCoas.values());

    // trialData.push({
    //   code: coaCode,
    //   desc: desc,
    //   credit: credit,
    //   debit: debit,
    // });

    
    

    trialData.push({
      code: "510010",
      desc: "Accumulated Fund",
      credit: 0,
      debit: sumArray(response.debt.filter(a=>a.type == 1).map((res) => parseFloat(res.amount))) + 
      sumArray(response.opening.filter(a=>a.type == 'COA' && a.fkey[0] == 4).map((res) => parseFloat(res.amount))) - sumArray(response.opening.filter(a=>a.type == 'Cashbook').map((res) => parseFloat(res.amount)))
      - sumArray(response.opening.filter(a=>a.type == 'COA' && a.fkey[0] == 3).map((res) => parseFloat(res.amount))) ,
    });
    totalDebits += sumArray(response.debt.filter(a=>a.type == 1).map((res) => parseFloat(res.amount))) + 
    sumArray(response.opening.filter(a=>a.type == 'COA' && a.fkey[0] == 4).map((res) => parseFloat(res.amount))) - sumArray(response.opening.filter(a=>a.type == 'Cashbook').map((res) => parseFloat(res.amount)))
    - sumArray(response.opening.filter(a=>a.type == 'COA' && a.fkey[0] == 3).map((res) => parseFloat(res.amount))) ;

    trialData.push({
      code: "411110",
      desc: "Creditors Control Account",
      debit: 0,
      credit: totalCred - sumArray(response.supplier.filter((a) => a.type == 2 && a.expense == 'None').map((res) => parseFloat(res.amount))),
    });
   
    totalCredits += totalCred - sumArray(response.supplier.filter((a) => a.type == 2).map((res) => parseFloat(res.amount)));

    setTrialBalanceData(trialData);
    setTotalDebit(totalDebits);
    setTotalCredit(totalCredits);
  };

  const sumArray = (arr) => arr.reduce((sum, num) => sum + num, 0);

  useEffect(() => {
    if(rdata.bills){
      fetchData();
      setLoading(false)
    }
  }, [rdata]);

  let tcred = 0.0
  let tdeb = 0.0

  return (
    <div className="container mx-auto p-4">
      {
        loading?
        <>
         <div className='flex justify-center items-center h-full w-full text-blue-950 text-5xl p-5 m-5 '>
            <FaSpinner size={50} className="spinner"  />
          </div>
        </>
        :
        <>
        
         <div className='text-center'>
              <h2 className='font-bold text-2xl'>{allData.council[0]?.name.toUpperCase()}</h2>
              <h2 className="font-bold text-2xl my-3">{'Trial Balance'.toUpperCase()}</h2>
              <h3 className='text-xl font-bold'>From {formatDate(startDate)} to {formatDate(endDate)}</h3>
          </div>
      <div className="flex items-center justify-between border-b pb-4">
    
      </div>
      <table className="table-auto w-full mt-4 border-collapse border border-gray-300 shadow-lg rounded-lg">
  <thead className="bg-blue-950 text-white text-left p-2">
    <tr className="p-2">
      <th className="px-4 py-2 border-b border-gray-300">Code</th>
      <th className="px-4 py-2 border-b border-gray-300">Description</th>
      <th className="px-4 py-2 border-b border-gray-300 text-right">Debit</th>
      <th className="px-4 py-2 border-b border-gray-300 text-right">Credit</th>
    </tr>
  </thead>
  <tbody>
    {trialBalanceData.sort((a, b) => a.code - b.code).map((entry, index) => {

      // const displayedDebit = Math.max(entry.debit, 0) + Math.max(-entry.credit, 0);
      // const displayedCredit = Math.max(entry.credit, 0) + Math.max(-entry.debit, 0);

      const debit = entry.debit;
  const credit = entry.credit;
  let displayedDebit = 0;
  let displayedCredit = 0;

  // If both debit and credit have non-zero values
  if (debit !== 0 && credit !== 0) {
    const difference = debit - credit;
    if (difference > 0) {
      displayedDebit = difference; // Positive difference → debit
    } else if (difference < 0) {
      displayedCredit = Math.abs(difference); // Negative difference → credit
    }
    // If difference = 0, both remain 0
  } else {
    // Handle cases where only one side has a value
    displayedDebit = Math.max(debit, -credit); // Debit or moved negative credit
    displayedCredit = Math.max(credit, -debit); // Credit or moved negative debit
  }

      tdeb += displayedDebit
      tcred += displayedCredit
  return (
    <tr
      key={index}
      className={`text-gray-700 hover:bg-gray-100 ${
        index % 2 === 0 ? "bg-gray-50" : "bg-white"
      }`}
    >
      <td className="px-4 py-3 border-b border-gray-300">{entry.code}</td>
      <td className="px-4 py-3 border-b border-gray-300">{entry.desc}</td>
      <td className="px-4 py-3 border-b border-gray-300 text-right">
        {formatToZMW(displayedDebit.toFixed(2))}
      </td>
      <td className="px-4 py-3 border-b border-gray-300 text-right">
        {formatToZMW(displayedCredit.toFixed(2))}
      </td>
    </tr>
  );
})}
  </tbody>
  <tfoot>
    <tr className="text-gray-800 font-semibold bg-gray-200">
      <th colSpan="2" className="px-4 py-3 text-left border-t border-gray-300">
        Total
      </th>
      <th className="px-4 py-3 text-right border-t border-gray-300">
        {formatToZMW(tdeb.toFixed(1))}
      </th>
      <th className="px-4 py-3 text-right border-t border-gray-300">
        {formatToZMW(tcred.toFixed(1))}
      </th>
    </tr>
  </tfoot>
</table>

      <div className={`mt-4 ${Math.abs(tdeb - tcred) < 0.05? "text-blue-500" : "text-red-500"}`}>
        {/* Trial Balance is {totalDebit === totalCredit ? "Balanced" : "Not Balanced"} */}
        Trial Balance is {Math.abs(tdeb - tcred) < 0.05 ? "Balanced" : "Not Balanced"}
      </div>
        </>
      }
      
    </div>
  );
}
